/**
 * plane-glyph.ts — the airline's plane drawn solid, registered once, and the
 * plane mark it makes, laid on its side to fly right. It is the game's
 * GAME_GLYPH.plane (components/game/common/game-glyphs.ts) and the plane
 * mark's drawing (plane-mark.tsx, and a round mark's on the session's end),
 * and it lives here, under the game and the ways in alike, because the ways in
 * come before a match and may not import the game's components: a swap of the
 * drawing reaches all of them.
 */

import fleetBadge from '../../assets/icons/vesper/fleet-badge.svg';
import { glyphs, turned } from '../ui/glyphs';

/** The plane drawn solid: the Fleet badge's drawing, at any size. */
export const PLANE_GLYPH = glyphs({ plane: fleetBadge }).plane;

/**
 * The plane mark: the plane, laid on its side to fly right — what PlaneMark
 * draws, and what a round mark holds on the session's end. The turn is the
 * drawing's own (turned()), so it reaches every Icon the mark is passed to
 * without a prop beside it; turning the plane anywhere else is the mark made
 * by hand (design:check, plane-mark-by-hand).
 */
export const PLANE_MARK = turned(PLANE_GLYPH);
